export default {
  getSurveyFields: state => state.fields,
  getSurveyStep: state => state.step,
}
